export default [
  'BOTSingupUserInfo'
]

/*
Appears on:
/modals/email-signup
*/
